import React, { FC, useEffect } from 'react';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from 'config/constants';
import { PropertyBox, PropertyLabel } from 'components/property-settings/property-shared-styles';
import { Box, Typography } from '@mui/material';

type OrthodonticsColorProps = {
    handleSettings: (propertyName: string, settingValue: string) => void;
    partOrthoColor: string;
    options?: string[];
    isRequired?: boolean;
};

const OrthodonticsColor: FC<OrthodonticsColorProps> = ({
    handleSettings,
    partOrthoColor,
    options,
    isRequired,
}: OrthodonticsColorProps) => {
    const { t: translate } = useTranslation(['construction-props']);
    const [orthoColor, setOrthoColor] = React.useState('');

    useEffect(() => {
        if (partOrthoColor) {
            setOrthoColor(partOrthoColor);
        }
    }, [partOrthoColor]);

    const handleChange = (event: SelectChangeEvent<string>) => {
        setOrthoColor(event.target.value);
        handleSettings('orthColor', event.target.value);
    };

    const colorOptions = options ? options : CONSTANTS.ORTHODONTICS_COLORS;

    return (
        <PropertyBox>
            <Box display="flex">
                <PropertyLabel variant="h5">{translate('ORTHODONTICS_COLORS')}</PropertyLabel>
                {isRequired && (
                    <Typography
                        component="span"
                        color="error"
                        fontSize={18}
                        sx={{ marginLeft: '2px', marginTop: '-5px' }}
                    >
                        *
                    </Typography>
                )}
            </Box>
            <FormControl fullWidth>
                <InputLabel id="ortho-color-label">{translate('COLOR')}</InputLabel>
                <Select
                    labelId="ortho-color-label"
                    id="ortho-color-select"
                    value={orthoColor}
                    onChange={handleChange}
                    label={translate('COLOR')}
                >
                    {colorOptions.map((color, index) => {
                        return (
                            <MenuItem key={index} value={color}>
                                {translate(color.toUpperCase())}
                            </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
        </PropertyBox>
    );
};

export default OrthodonticsColor;
